import { differenceInDays, differenceInMilliseconds } from 'date-fns';
import { MILLISECONDS_IN_DAY } from '../../constants';
import type { ScheduleSolversTimeConfigType } from '../../types';

export const weeklyOnTime = ({
  startDate,
  endDate,
  userDate
}: ScheduleSolversTimeConfigType) => {
  const viewDuration = differenceInMilliseconds(endDate, startDate);
  const fromNowToStart = differenceInMilliseconds(userDate, startDate);
  const daysBetweenStartAndEnd = differenceInDays(endDate, startDate);

  const timeFromStart =
    fromNowToStart %
    (MILLISECONDS_IN_DAY * Math.max(1, daysBetweenStartAndEnd));

  return viewDuration - timeFromStart;
};
